<template>
    <div>
        <review-form 
            :is-review-form-sidebar-active.sync="isReviewFormSidebarActive"
            :review-data="reviewData"
            @refetch-data="refetchData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    />
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            /> 
                            <b-button
                                variant="primary"
                                @click="updateReview()"
                            >
                                <span class="text-nowrap">Add Review</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!reviews.length"
                :items="reviews"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="(col, index) in tableColumns" :key="index">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <draggable v-if="reviews.length > 0" v-model="reviews" tag="tbody" hadle=".handle" @change="updateOrdering()">
                    <tr v-for="(item, index) in reviews" :key="index">
                        <th scope="row" class="pl-2">
                            <feather-icon size="24" icon="MenuIcon"/> 
                        </th>
                        <td class="pl-2">
                            <b-img
                            :src="item.cover_image ? item.cover_image: require('@/assets/images/no-image.png')"
                            height="110"
                            width="170"
                            class="rounded m-0"
                            />
                        </td>
                        <td class="pl-2">
                            <span>{{ item.title[currentLocale] }}</span>
                        </td>
                        <td class="pl-2">
                            <span>{{ item.slug[currentLocale] }}</span>
                        </td>
                        <td class="pl-2">
                            <b-badge
                            pill
                            :variant="`light-${resolveReviewStatusVariant(item.is_active)}`"
                            class="text-capitalize"
                            >
                                {{ resolveReviewStatusnameVariant(item.is_active) }} 
                            </b-badge>
                        </td>
                        <td class="pl-2">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateReview(item)" variant="outline-success">Edit</b-button>
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                        </td>
                    </tr>
                </draggable>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalReview"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, BImgLazy,
    BFormRating
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import store from '@/store'
import { ref,onUnmounted } from '@vue/composition-api'

import ReviewForm from '../review-form/ReviewForm.vue'
import reviewStoreModule from '../reviewStoreModule'
import useReviewList from './useReviewList'

export default {
    components:{
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup,
        BFormCheckbox, BImg, BImgLazy, draggable, BFormRating, ReviewForm, vSelect
    },

    directives:{
        'b-modal': VBModal,
        Ripple
    },
    
    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },

    setup() {
        const REVIEW_STORE_MODULE_NAME = 'app-review';
        if (!store.hasModule(REVIEW_STORE_MODULE_NAME)) store.registerModule(REVIEW_STORE_MODULE_NAME, reviewStoreModule)
        onUnmounted(() => {
            if (store.hasModule(REVIEW_STORE_MODULE_NAME)) store.unregisterModule(REVIEW_STORE_MODULE_NAME)
        });

        const {
            tableColumns,
            isReviewFormSidebarActive,
            reviewData,
            refetchData,
            fetchData,
            searchQuery,
            updateReview,
            reviews,
            dataMeta,
            totalReview,
            perPage,
            currentPage,
            resolveReviewStatusVariant,
            resolveReviewStatusnameVariant,
            updateOrdering,
            deleteData,
        } = useReviewList()

        fetchData()

        return {
            tableColumns,
            isReviewFormSidebarActive,
            reviewData,
            refetchData,
            fetchData,
            searchQuery,
            updateReview,
            reviews,
            dataMeta,
            totalReview,
            perPage,
            currentPage,
            resolveReviewStatusVariant,
            resolveReviewStatusnameVariant,
            updateOrdering,
            deleteData,
        }
    },

    methods: {
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm(`Please confirm that you want to delete review ID = ${id}`, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                    this.deleteData(id)
                }
            })
        },
    },
}
</script>